import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Modal from '../../../components/Modal';
import { Button, ButtonGroup } from '../../../components/Buttons';
import { useTranslation } from 'react-i18next';
import { H2, P } from '../../../components/Typography';
import { Input, InputValidation } from '../../../components/Forms';
import { distances, colors, border } from '../../../styles/constants';
import Hr from '../../../components/Hr';

interface ChangeCustomerIdModalProps {
    accountId: string;
    customerId: string;
    closeModal: () => void;
    changeCustomerId: (accountId: string, oldCustomerId: string,  newCustomerId: string) => void;
    changeCustomerIdError: string;
}

const sainitize = (value: string | undefined) => (
    (value || '').replace(/\\/g, '').replace(/\//g, '').replace(/\s/g, '')
);

const ChangeCustomerIdModal = ({
    accountId,
    customerId,
    closeModal,
    changeCustomerId,
    changeCustomerIdError,
}: ChangeCustomerIdModalProps) => {
    const { t } = useTranslation();
    const [newId, setNewId] = useState<string>('');

    return (
        <Modal>
            <H2>{t('customers.customer.change_customer_id.title')}</H2>
            <P>{t('customers.customer.change_customer_id.text')}</P>
            <Hr />
            <form onSubmit={(e) => {
                e.preventDefault();
                if (newId) {
                    changeCustomerId(accountId, customerId, newId);
                }
            }} >
                <Input
                    name="newId"
                    label={t('customers.customer.change_customer_id.new_customer_id_label')}
                    onChange={e => setNewId(sainitize(e.currentTarget.value))}
                    onBlur={e => setNewId(sainitize(e.currentTarget.value))}
                    value={newId}
                    placeholder=""
                    validation={changeCustomerIdError ? {
                        state: 'invalid',
                        message: t('customers.customer.change_customer_id.new_customer_id_invalid', { id: changeCustomerIdError }),
                    } as InputValidation: undefined}
                    autoFocus
                />
                <ButtonGroup>
                    <Button type="submit">
                        {t('customers.customer.change_customer_id.confirm')}
                    </Button>

                    <Button className="alt" type="button" onClick={closeModal}>
                        {t('customers.customer.change_customer_id.cancel')}
                    </Button>
                </ButtonGroup>
            </form>

        </Modal>
    );
};

export default ChangeCustomerIdModal;
